<template>
  <b-modal
    id="order-complete-no-invoice"
    modal-class="modal-style two-footer-btn"
    ref="modal"
    ignore-enforce-focus-selector=".vld-overlay"
  >
    <!-- //TODO: currency fomat -->
    <template>
      <p class="modal-style-title modal-title">訂購完成</p>
      <div class="modal-style-content">
        <p>因尚有未收金額 $ {{ unpaidAmount }}，無法開立發票</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="routeTo">
        確認
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    unpaidAmount: {
      required: false,
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    routeTo() {
      this.$router.push({ name: '歷史購買紀錄' });
      this.$emit('confirm');
    }
  }
};
</script>

<style lang="scss" scoped></style>
